import { Link } from 'react-router-dom';

export default function VoucherSection() {
  return (
    <section className="py-36 bg-gradient-to-b from-white to-[#F0FDFA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20 text-center">
          <span className="text-sm font-medium text-[#0F766E] mb-3 block">정부 지원 사업</span>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            정부 지원 사업 수행
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg p-12 border border-[#99F6E4]/30 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-6">
              <i className="ri-robot-line text-4xl text-[#0D9488]"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">AI 바우처 사업</h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              중소·중견기업의 AI 도입을 지원하는 정부 바우처 사업을 수행합니다.
              AI 기술 컨설팅부터 실제 시스템 구축까지 전 과정을 지원합니다.
            </p>
            <Link
              to="/voucher"
              className="inline-flex items-center text-sm font-medium text-[#0D9488] hover:text-[#0F766E] transition-colors cursor-pointer whitespace-nowrap"
            >
              AI 바우처 보기
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className="bg-white rounded-lg p-12 border border-[#99F6E4]/30 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-6">
              <i className="ri-database-2-line text-4xl text-[#0D9488]"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">데이터 바우처 사업</h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-8">
              기업의 데이터 활용 역량 강화를 위한 정부 바우처 사업을 수행합니다.
              데이터 수집·가공·분석·활용까지 전문적인 솔루션을 제공합니다.
            </p>
            <Link
              to="/voucher"
              className="inline-flex items-center text-sm font-medium text-[#0D9488] hover:text-[#0F766E] transition-colors cursor-pointer whitespace-nowrap"
            >
              데이터 바우처 보기
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
